import {
    HelperText,
    SettingName,
    SettingRow,
    SettingValue,
} from 'pages/Settings/V4SensorSettings/styled';
import { PropsWithChildren, ReactNode } from 'react';

type SettingProps = PropsWithChildren<{
    name: ReactNode;
    indented?: boolean;
    helperText?: string;
}>;

export function Setting({ name, indented = false, helperText, children }: SettingProps) {
    return (
        <SettingRow>
            <SettingName $indented={indented}>{name}</SettingName>
            <SettingValue>{children}</SettingValue>
            {helperText ? <HelperText>{helperText}</HelperText> : null}
        </SettingRow>
    );
}
